import { AxiosResponse } from "axios";
import { API } from "../index";

export const inquiryService = {
  getComments: async (articleId: string): Promise<AxiosResponse> => {
    return await API.get(`/inquiry/comments/?article_id=${articleId}`);
  },

  getArticleList: async (subdomain: string, modes: string): Promise<AxiosResponse> => {
    return await API.get(`/inquiry/articles/?subdomain=${subdomain}&modes=${modes}`);
  },

  getPublicAnnouncements: async (subdomain: string, limit?: number): Promise<AxiosResponse> => {
    const params = new URLSearchParams();
    params.append('subdomain', subdomain);
    params.append('modes', '4,5'); // 공지사항과 FAQ
    params.append('is_private', 'false'); // 공개된 것만
    if (limit) params.append('limit', limit.toString());
    
    return await API.get(`/inquiry/articles/?${params.toString()}`);
  },

  getInquiryArticleList: async (query: string): Promise<AxiosResponse> => {
    return await API.get(`/inquiry/article-list/${query}`);
  },

  getInquiryHeadBanner: async (): Promise<AxiosResponse> => {
    return await API.get(`/inquiry/head-banner/`);
  },

  postInquiryExtraInfo: async (articleId: number, need: boolean, extraInfo: string): Promise<AxiosResponse> => {
    return await API.post(`/inquiry/extra-info/`, {
      article_id: articleId,
      need_extra_info: need,
      extra_info: extraInfo,
    });
  },

  getArticleById: async (id: string): Promise<AxiosResponse> => {
    return await API.get(`/inquiry/articles/${id}/`);
  },

  deleteArticleById: async (id: string): Promise<AxiosResponse> => {
    return await API.delete(`/inquiry/articles/${id}/`);
  },

  // Enhanced method for news functionality
  getInquiries: async (params?: {
    page?: number;
    page_size?: number;
    mode?: string;
    search?: string;
    is_private?: boolean;
  }): Promise<AxiosResponse> => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.append('page', params.page.toString());
    if (params?.page_size) searchParams.append('page_size', params.page_size.toString());
    if (params?.mode) searchParams.append('modes', params.mode);
    if (params?.search) searchParams.append('search', params.search);
    if (params?.is_private !== undefined) searchParams.append('is_private', params.is_private.toString());
    
    return await API.get(`/inquiry/articles/?${searchParams.toString()}`);
  }
};